var prc_collections_carousels = [];

document.addEventListener("DOMContentLoaded", function () {
    const carousels = document.querySelectorAll('.collections-carousel');
    
    carousels.forEach(carousel => {
        prc_collections_carousels.push(carousel.parentElement.innerHTML);
        carousel.parentElement.remove();
    });

    let content_area = document.querySelector('.article__inner > .article__content');
    let html = content_area.innerHTML;
    // Regex to find the shortcode and its attributes
    let regex = new RegExp(`\\[prc-collections-carousel]`, 'g');
    let match;
    let loop_count = 0;

    
    // Replace each shortcode instance
    console.log(loop_count, prc_collections_carousels.length);
    while ((match = regex.exec(html)) !== null) {

        if(loop_count >= prc_collections_carousels.length) break;
        
        html = html.replace(match[0], prc_collections_carousels[loop_count]);
        content_area.innerHTML = html;
        
        loop_count++;
    }

    $('.collections-carousel').owlCarousel({
        loop: true,
        margin: 10,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: false
            },
            600: {
                items: 2,
                nav: false
            },
            1000: {
                items: 3,
                nav: false,
                loop: false
            }
        }
    });

});